import { Fetcher } from '@inflearn/fe-shared-utils';
import { API_ENDPOINT, COURSE_API_URL, COURSE_API_URL_INTERNAL } from '../appConfig';

const REQUEST_TIME_OUT = 10 * 1000;

export type RequestOptions = {
  headers?: HeadersInit;
  timeout?: number;
  cache?: RequestCache;
  baseURL?: string;
  credentials?: RequestCredentials;
};

const getEndpoint = ({ publicUrl, internalUrl }: { publicUrl: string; internalUrl: string }) => {
  if (typeof window === 'undefined') {
    return internalUrl;
  }

  return publicUrl;
};

export const headerFetcher = new Fetcher({ baseUrl: API_ENDPOINT, credentials: 'include' });
export const courseFetcher = new Fetcher({
  baseUrl: getEndpoint({ publicUrl: COURSE_API_URL, internalUrl: COURSE_API_URL_INTERNAL }),
  credentials: 'include',
  timeout: REQUEST_TIME_OUT,
});
